import { Col, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap'
import './styles.css'
import { useState } from 'react';
import TableView from './components/TableView/TableView';
import ChartView from './components/ChartView/ChartView';

function RelatorioTabs() {
  const [activeTab, setActiveTab] = useState('1');
  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <div>
      <h3 className="titleRelatorio">Todos os relatórios</h3>
      <br />
      <Nav tabs>
        <NavItem>
          <NavLink
             className={activeTab === '1' ? 'active' : ''}
            onClick={() => toggle('1')}
            style={{ cursor: 'pointer' }}
          >
            Gráfico
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === '2' ? 'active' : ''}
            onClick={() => toggle('2')}
            style={{ cursor: 'pointer' }}
          >
            Tabela
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <Row>
            <Col sm="12" md="12">
              
              <ChartView />
            </Col>
          </Row>
        </TabPane>
        <TabPane tabId="2">
          <Row>
            <Col sm="12"  md="12">
              <TableView />
            </Col>
          </Row>
        </TabPane>
      </TabContent>
</div>
  )
}

export default RelatorioTabs